import { faArrowRightToBracket } from "@fortawesome/pro-solid-svg-icons/faArrowRightToBracket";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import Grid from "@mui/material/Grid";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { ButtonCancel } from "components/buttons";
import { ButtonSelect } from "components/buttons/ButtonSelect";
import moment, { Moment } from "moment";
import * as React from "react";
import { useState } from "react";

export type SelectedPeriod = {
    start: Date;
    end: Date;
};

interface IProps {
    startDate?: Date | null;
    endDate?: Date | null;
    onClose: (period?: SelectedPeriod) => void;
    minDate?: Date | null;
    maxDate?: Date | null;
}

export const MprcSelectPeriod: React.FC<IProps> = (props) => {
    const { minDate, maxDate, onClose } = props;
    const [startDate, setStartDate] = useState<Moment | null>(moment(props.startDate ?? new Date()));
    const [endDate, setEndDate] = useState<Moment | null>(moment(props.endDate ?? new Date()));

    return (
        <Dialog
            open
            onClose={() => onClose(undefined)}
        >
            <DialogContent>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid>
                        <DateCalendar
                            maxDate={endDate ?? moment(minDate)}
                            value={startDate}
                            onChange={(newValue) => setStartDate(newValue)}
                        />

                    </Grid>
                    <Grid>
                        <FontAwesomeIcon icon={faArrowRightToBracket} size="2x" />
                    </Grid>
                    <Grid>
                        <DateCalendar
                            minDate={startDate ?? moment(maxDate)}
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonCancel onClick={() => onClose(undefined)} />
                <ButtonSelect
                    variant="contained"
                    onClick={() =>
                        onClose({
                            start: startDate!.toDate().putStartOfDay(),
                            end: endDate!.toDate().putEndOfDay()
                        })
                    }
                    disabled={startDate == null || endDate == null || startDate > endDate}
                />
            </DialogActions>
        </Dialog>
    );
};
